import { combineReducers } from "redux";
import channelReducer from "./channel";
import checkoutReducer from "./checkout";
import workingDocumentReducer from "./workingDocument";
import {
  documentListReducer,
  filteredListReducer,
  ifsLatestReducer,
  documentSearchReducer,
  documentUrlReducer,
  documentDetailsReducer,
  previewInTeamsReducer,
  uploadToOneDriveReducer,
  documentCheckoutFlowReducer,
} from "./documents";
import newRevisionInfoReducer from "./documents/newRevisionInfoSlice";
import checkinNewRevisionReducer from "./documents/checkinNewRevisionSlice";
import templatesReducer from "./templates";
import templatesPanelReducer from "./templates/templatesPanelSlice";
import {
  oneDriveReducer,
  filteredOneDriveReducer,
  oneDriveDocsListReducer,
  oneDriveDeleteReducer,
  oneDriveDownloadReducer,
} from "./oneDrive";
import checkinReducer from "./checkin";
import checkinApiReducer from "./checkinApi";
import objectsReducer from "./objects/objectsSlice";
import loginReducer from "./login";
import ifsUserReducer from "./ifsUser";
import requireRefreshReducer from "./requireRefresh/requireRefreshSlice";
import metadataReducer from "./metadata";
import authFlowReducer from "./authFlow/authFlowSlice";
import documentsReducer from "./documents";

const rootReducer = combineReducers({
  Metadata: metadataReducer,
  AuthFlow: authFlowReducer,
  WorkingDocumnetStore: workingDocumentReducer,
  Documents: documentListReducer,
  FilteredDocuments: filteredListReducer,
  IfsLatestDocument: ifsLatestReducer,
  DocumentSearch: documentSearchReducer,
  DocumentUrl: documentUrlReducer,
  DocumentDetails: documentDetailsReducer,
  PreviewInTeams: previewInTeamsReducer,
  UploadToOneDrive: uploadToOneDriveReducer,
  DocumentCheckoutFlow: documentCheckoutFlowReducer,
  NewRevisionInfo: newRevisionInfoReducer,
  CheckinNewRevision: checkinNewRevisionReducer,
  ChannelStore: channelReducer,
  CheckinDocument: checkinReducer,
  CheckinApi: checkinApiReducer,
  CheckoutDocument: checkoutReducer,
  FilteredTemplates: templatesReducer,
  TemplatesPanel: templatesPanelReducer,
  FilteredOneDriveDocuments: filteredOneDriveReducer,
  OneDriveDocuments: oneDriveReducer,
  OneDriveDocsList: oneDriveDocsListReducer,
  OneDriveDelete: oneDriveDeleteReducer,
  OneDriveDownload: oneDriveDownloadReducer,
  Login: loginReducer,
  IfsUser: ifsUserReducer,
  objects: objectsReducer,
  DocumentsSlice: documentsReducer,
  RequireRefresh: requireRefreshReducer,
});

export default rootReducer;